export { default } from './RelatedArticles';


// WEBPACK FOOTER //
// ./src/partials/modules/RelatedArticles/index.js